import React, { useState, useEffect } from "react";
import { toast } from 'react-toastify';
import ColorPicker from "../../../components/ColorPicker";
import CssCodeEditor from "../../../components/CssCodeEditor";
import JsCodeEditor from "../../../components/JsCodeEditor";

const StyleTab = ({ handleLayoutChange, selectedLayout,updateLogoShowcaseTabData,logoShowcaseTabData }) => {
    const [activeSettingElementsTab, setActiveSettingElementsTab] = useState("main");
    const [fontType, setFontType] = useState(logoShowcaseTabData.font_type);
    const [fontTypeDropdownOpen, setFontTypeDropdownOpen] = useState(false);
    const [backgroundColor, setBackgroundColor] = useState(logoShowcaseTabData.background_color);
    const [logoCustomColor, setLogoCustomColor] = useState(logoShowcaseTabData.logo_custom_color);
    const [logoBackgroundColor, setLogoBackgroundColor] = useState(logoShowcaseTabData.logo_background_color);
    const [headerTitleColor, setHeaderTitleColor] = useState(logoShowcaseTabData.header_title_color);
    const [headerCaptionColor, setHeaderCaptionColor] = useState(logoShowcaseTabData.header_caption_color);
    const [headerLinkColor, setHeaderLinkColor] = useState(logoShowcaseTabData.header_link_color);
    const [activeAlignmentSection, setActiveAlignmentSection] = useState(logoShowcaseTabData.position_alignment);
    const [headerTitleFontSize, setHeaderTitleFontSize] = useState(logoShowcaseTabData.header_title_font_size);
    const [headerTitleFontSizeDropdownOpen, setHeaderTitleFontSizeDropdownOpen] = useState(false);
    const [headerCaptionFontSize, setHeaderCaptionFontSize] = useState(logoShowcaseTabData.header_caption_font_size);
    const [headerCaptionFontSizeDropdownOpen, setHeaderCaptionFontSizeDropdownOpen] = useState(false);
    const [buttonColor, setButtonColor] = useState(logoShowcaseTabData.button_color);
    const [buttonTextColor, setButtonTextColor] = useState(logoShowcaseTabData.button_text_color);
    const [buttonFontSize, setButtonFontSize] = useState(logoShowcaseTabData.button_font_size);
    const [buttonFontSizeDropdownOpen, setButtonFontSizeDropdownOpen] = useState(false);
    const [styleTabCustomCss, setStyleTabCustomCss] = useState(logoShowcaseTabData.custom_css);
    const [jsTabCustomJs, setJsTabCustomJs] = useState(logoShowcaseTabData.custom_js);

    // Handlers Font Type Change
    const handleFontTypeChange = (font) => {
        setFontType(font);
        updateLogoShowcaseTabData("font_type", font);
        setFontTypeDropdownOpen(false);
    };

    // Handlers Background Color Change
    const handleBackgroundColorChange = (color) => {
        setBackgroundColor(color.hex);
        updateLogoShowcaseTabData("background_color", color.hex);
    };

    // Handlers Logo Custom Color Change
    const handleLogoCustomColorChange = (color) => {
        setLogoCustomColor(color.hex);
        updateLogoShowcaseTabData("logo_custom_color", color.hex);
    };

    // Handlers Logo Background Color Change
    const handleLogoBackgroundColorChange = (color) => {
        setLogoBackgroundColor(color.hex);
        updateLogoShowcaseTabData("logo_background_color", color.hex);
    };

    // Handle Position Alignment change
    const handleActiveAlignmentInputChange = (event) => {
        setActiveAlignmentSection(event.target.value);
        updateLogoShowcaseTabData("position_alignment", event.target.value);
    };

    // Handlers Header Title Color Change
    const handleHeaderTitleColorChange = (color) => {
        setHeaderTitleColor(color.hex);
        updateLogoShowcaseTabData("header_title_color", color.hex);
    };

    // Handlers Header Caption Color Change
    const handleHeaderCaptionColorChange = (color) => {
        setHeaderCaptionColor(color.hex);
        updateLogoShowcaseTabData("header_caption_color", color.hex);
    };

    // Handlers Header Link Color Change
    const handleHeaderLinkColorChange = (color) => {
        setHeaderLinkColor(color.hex);
        updateLogoShowcaseTabData("header_link_color", color.hex);
    };

    // Handlers Header Title Font Size Change
    const handleHeaderTitleFontSizeChange = (font) => {
        setHeaderTitleFontSize(font);
        updateLogoShowcaseTabData("header_title_font_size", font);
        setHeaderTitleFontSizeDropdownOpen(false);
    };

    // Handlers Header Caption Font Size Change
    const handleHeaderCaptionFontSizeChange = (font) => {
        setHeaderCaptionFontSize(font);
        updateLogoShowcaseTabData("header_caption_font_size", font);
        setHeaderCaptionFontSizeDropdownOpen(false);
    };

    // Handlers Button Color Change
    const handleButtonColorChange = (color) => {
        setButtonColor(color.hex);
        updateLogoShowcaseTabData("button_color", color.hex);
    };

    // Handlers Button Text Color Change
    const handleButtonTextColorChange = (color) => {
        setButtonTextColor(color.hex);
        updateLogoShowcaseTabData("button_text_color", color.hex);
    };

    // Handlers Button  Font Type Change
    const handleButtonFontSizeChange = (font) => {
        setButtonFontSize(font);
        updateLogoShowcaseTabData("button_font_size", font);
        setButtonFontSizeDropdownOpen(false);
    };

    // Handlers Custom CSS Change
    const handleCustomcssCodeChange = (code) => {
        setStyleTabCustomCss(code);
        updateLogoShowcaseTabData("custom_css", code);
    };
    
    //Inject CSS into the page whenever it changes
    useEffect(() => {
        let styleTag = document.getElementById("custom-style");

        if (!styleTag) {
            styleTag = document.createElement("style");
            styleTag.id = "custom-style";
            document.head.appendChild(styleTag);
        }

        styleTag.innerHTML = styleTabCustomCss || "";
    }, [styleTabCustomCss]);

    // Handlers Custom Js Change
    const handleCustomJsCodeChange = (code) => {
        setJsTabCustomJs(code);
        updateLogoShowcaseTabData("custom_js", code);
    }; 

    // Function to run the JS code when Validate is clicked
    const handleValidateClick = () => { 
        const existingScript = document.getElementById("custom-js");
        if (existingScript) {
            existingScript.remove();
        }
    
        if (jsTabCustomJs && jsTabCustomJs.trim() !== "") {
            const script = document.createElement("script");
            script.id = "custom-js";
            script.type = "text/javascript";
            script.innerHTML = jsTabCustomJs;
    
            document.body.appendChild(script);
    
            toast.success("Custom JS applied successfully");
        } else {
            toast.error("No JS code to apply");
        }
    };
    
    return (
        <div className="testimonials-side-baar-layout-tab">
            {activeSettingElementsTab === "main" && (
                <>
                    <span>Style</span>
                    <div className="side-baar-box-header">
                        <div className="box-header-row">
                            <span>Font</span>
                            <div className="color-pikr-box" onClick={() => setFontTypeDropdownOpen(!fontTypeDropdownOpen)}>
                                <em>{fontType}</em>
                                {fontTypeDropdownOpen && (
                                    <ul className="dropdown-list">
                                        {["Default"].map((font) => (
                                            <li key={font} onClick={() => handleFontTypeChange(font)}>
                                                {font}
                                            </li>
                                        ))}
                                    </ul>
                                )}
                            </div>
                        </div>
                    </div>
                    <div className="customize-elements-list">
                        <ul>
                            <li>
                                <button onClick={() => setActiveSettingElementsTab("background")}>Background<i className="fa fa-angle-right" aria-hidden="true"></i></button>
                            </li>
                            <li>
                                <button onClick={() => setActiveSettingElementsTab("logo_style")}>Logo Style<i className="fa fa-angle-right" aria-hidden="true"></i></button>
                            </li>
                            <li>
                                <button onClick={() => setActiveSettingElementsTab("header_style")}>Header Style<i className="fa fa-angle-right" aria-hidden="true"></i></button>
                            </li>
                            <li>
                                <button onClick={() => setActiveSettingElementsTab("button_style")}>Button Style<i className="fa fa-angle-right" aria-hidden="true"></i></button>
                            </li>
                        </ul>
                    </div>

                    <div className="customize-elements-list">
                        <ul>
                            <li>
                                <button onClick={() => setActiveSettingElementsTab("custom_css")}>Custom Css <i className="fa fa-angle-right" aria-hidden="true"></i></button>
                            </li>
                            <li>
                                <button onClick={() => setActiveSettingElementsTab("custom_js")}>Custom JS <i className="fa fa-angle-right" aria-hidden="true"></i></button>
                            </li>
                        </ul>
                    </div>
                </>
            )}

            {activeSettingElementsTab === "background" && (
                <>
                    <div className="inner-box-layout">
                        <span><button onClick={() => setActiveSettingElementsTab("main")}><i className="fa fa-angle-left" aria-hidden="true"></i>Back</button> Background</span>
                        <div className="side-baar-box-header">
                            <div className="box-header-row">
                                <span>Background Color</span>
                                <div className="color-pikr-box">
                                    <ColorPicker color={backgroundColor} setColor={setBackgroundColor} onChangeComplete={handleBackgroundColorChange}/>
                                </div>
                            </div>
                        </div>
                    </div>
                </>
            )}

            {activeSettingElementsTab === "logo_style" && (
                <>
                    <div className="inner-box-layout">
                        <span><button onClick={() => setActiveSettingElementsTab("main")}><i className="fa fa-angle-left" aria-hidden="true"></i>Back</button> Logo Style</span>
                        <div className="side-baar-box-header">
                            <div className="box-header-row">
                                <span>Logo Custom Color</span>
                                <div className="color-pikr-box">
                                    <ColorPicker color={logoCustomColor} setColor={setLogoCustomColor} onChangeComplete={handleLogoCustomColorChange}/>
                                </div>
                            </div>
                            <div className="box-header-row">
                                <span>Logo Background Color</span>
                                <div className="color-pikr-box">
                                    <ColorPicker color={logoBackgroundColor} setColor={setLogoBackgroundColor} onChangeComplete={handleLogoBackgroundColorChange}/>
                                </div>
                            </div>
                            <p>Custom Color can be applied only to PNG and SVG files.</p>
                        </div>
                    </div>
                </>
            )}

            {activeSettingElementsTab === "header_style" && (
                <>
                    <div className="inner-box-layout">
                        <span><button onClick={() => setActiveSettingElementsTab("main")}><i className="fa fa-angle-left" aria-hidden="true"></i>Back</button> Header Style</span>
                        <div className="side-baar-box-header">
                            <div className="box-header-row">
                                <p>Alignment</p>
                                <div className="left-cnater-right-button">
                                    <label className="card-radio-btn">
                                        <input type="radio" name="alignment_type" className="card-input-element d-none" value="left" onChange={handleActiveAlignmentInputChange} checked={activeAlignmentSection === "left"} />
                                        <div className="card card-body">
                                            <div className="content_sub">Left</div>
                                        </div>
                                    </label>
                                    <label className="card-radio-btn">
                                        <input type="radio" name="alignment_type" className="card-input-element d-none" value="center" onChange={handleActiveAlignmentInputChange} checked={activeAlignmentSection === "center"} />
                                        <div className="card card-body">
                                            <div className="content_sub">Center</div>
                                        </div>
                                    </label>
                                    <label className="card-radio-btn">
                                        <input type="radio" name="alignment_type" className="card-input-element d-none" value="right" onChange={handleActiveAlignmentInputChange} checked={activeAlignmentSection === "right"} />
                                        <div className="card card-body">
                                            <div className="content_sub">Right</div>
                                        </div>
                                    </label>
                                </div>
                            </div>
                        </div>

                        <div className="side-baar-box-header">
                            <p>Colors</p>
                            <div className="box-header-row">
                                <span>Title Color</span>
                                <div className="color-pikr-box">
                                    <ColorPicker color={headerTitleColor} setColor={setHeaderTitleColor} onChangeComplete={handleHeaderTitleColorChange}/>
                                </div>
                            </div>
                            <div className="box-header-row">
                                <span>Caption Color</span>
                                <div className="color-pikr-box">
                                    <ColorPicker color={headerCaptionColor} setColor={setHeaderCaptionColor} onChangeComplete={handleHeaderCaptionColorChange}/>
                                </div>
                            </div>
                            <div className="box-header-row">
                                <span>Links Color</span>
                                <div className="color-pikr-box">
                                    <ColorPicker color={headerLinkColor} setColor={setHeaderLinkColor} onChangeComplete={handleHeaderLinkColorChange}/>
                                </div>
                            </div>
                        </div>

                        <div className="side-baar-box-header">
                            <p>Fonts</p>
                            <div className="box-header-row">
                                <span>Title Font Size</span>
                                <div className="color-pikr-box" onClick={() => setHeaderTitleFontSizeDropdownOpen(!headerTitleFontSizeDropdownOpen)}>
                                    <em>{headerTitleFontSize}</em>
                                    {headerTitleFontSizeDropdownOpen && (
                                        <ul className="dropdown-list">
                                            {["10px","11px","12px","13px","14px","15px","16px","17px","18px","19px","20px","22px","24px","26px","28px","30px","30px","34px","36px","40px","44px","48px","50px"].map((font) => (
                                                <li key={font} onClick={() => handleHeaderTitleFontSizeChange(font)}>
                                                    {font}
                                                </li>
                                            ))}
                                        </ul>
                                    )}
                                </div>
                            </div>
                            <div className="box-header-row">
                                <span>Caption Font Size</span>
                                <div className="color-pikr-box" onClick={() => setHeaderCaptionFontSizeDropdownOpen(!headerCaptionFontSizeDropdownOpen)}>
                                    <em>{headerCaptionFontSize}</em>
                                    {headerCaptionFontSizeDropdownOpen && (
                                        <ul className="dropdown-list">
                                            {["10px","11px","12px","13px","14px","15px","16px","17px","18px","19px","20px","22px","24px","26px","28px","30px","30px","34px","36px","40px","44px","48px","50px"].map((font) => (
                                                <li key={font} onClick={() => handleHeaderCaptionFontSizeChange(font)}>
                                                    {font}
                                                </li>
                                            ))}
                                        </ul>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </>
            )}

            {activeSettingElementsTab === "button_style" && (
                <>
                    <div className="inner-box-layout">
                        <span><button onClick={() => setActiveSettingElementsTab("main")}><i className="fa fa-angle-left" aria-hidden="true"></i>Back</button> Button Style</span>

                        <div className="side-baar-box-header">
                            <p>Colors</p>
                            <div className="box-header-row">
                                <span>Button Color</span>
                                <div className="color-pikr-box">
                                    <ColorPicker color={buttonColor} setColor={setButtonColor} onChangeComplete={handleButtonColorChange}/>
                                </div>
                            </div>
                            <div className="box-header-row">
                                <span>Button Text Color</span>
                                <div className="color-pikr-box">
                                    <ColorPicker color={buttonTextColor} setColor={setButtonTextColor} onChangeComplete={handleButtonTextColorChange}/>
                                </div>
                            </div>
                        </div>

                        <div className="side-baar-box-header">
                            <p>Fonts</p>
                            <div className="box-header-row">
                                <span>Title Font Size</span>
                                <div className="color-pikr-box" onClick={() => setButtonFontSizeDropdownOpen(!buttonFontSizeDropdownOpen)}>
                                    <em>{buttonFontSize}</em>
                                    {buttonFontSizeDropdownOpen && (
                                        <ul className="dropdown-list">
                                            {["10px","11px","12px","13px","14px","15px","16px","17px","18px","19px","20px","22px","24px","26px","28px","30px","30px","34px","36px","40px","44px","48px","50px"].map((font) => (
                                                <li key={font} onClick={() => handleButtonFontSizeChange(font)}>
                                                    {font}
                                                </li>
                                            ))}
                                        </ul>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </>
            )}

            {activeSettingElementsTab === "custom_css" && (
                <>
                    <div className="inner-box-layout">
                        <span><button onClick={() => setActiveSettingElementsTab("main")}><i className="fa fa-angle-left" aria-hidden="true"></i>Back</button> Custom CSS</span>
                        <div className="css-text height-text">
                            <CssCodeEditor code={styleTabCustomCss} setCode={setStyleTabCustomCss} onChangeComplete={handleCustomcssCodeChange}/>
                        </div>
                    </div>
                </>
            )} 

            {activeSettingElementsTab === "custom_js" && (
                <>
                    <div className="inner-box-layout">
                        <span><button onClick={() => setActiveSettingElementsTab("main")}><i className="fa fa-angle-left" aria-hidden="true"></i>Back</button> Custom Js</span>
                        <div className="css-text height-text">
                            <JsCodeEditor code={jsTabCustomJs} setCode={setJsTabCustomJs} onChangeComplete={handleCustomJsCodeChange}/>
                            <div className="save-css-js"><button className="save-css-js" onClick={handleValidateClick}>Validate</button></div>
                        </div>
                    </div>
                </>
            )}
        </div>
    );
};

export default StyleTab;